// src/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import ForbiddenPage from "./Error/ForbiddenPage";

const ProtectedRoute = ({ element: Component, allowedRoles = [], userRoles }) => {
  if (!userRoles || userRoles.length === 0) {
    return <Navigate to="/login" />;
  }

  const normalizeRole = (role) =>
    String(role || "")
      .trim()
      .toUpperCase()
      .replace(/[\s-]+/g, "_");

  const normalizedAllowedRoles = allowedRoles.map(normalizeRole);

  const hasAccess = userRoles.some((role) => {
    if (!role || typeof role !== "string") return false;
    return normalizedAllowedRoles.includes(normalizeRole(role));
  });

  if (!hasAccess) {
    return <ForbiddenPage />;
  }

  return Component;
};

export default ProtectedRoute;
